import React, { useState } from 'react';

const ThirdPartyIntegrationsUrlsSection = ({ integrationsUrls }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!integrationsUrls || Object.keys(integrationsUrls).length === 0) {
        return null;
    }

    const integrations = Object.entries(integrationsUrls);
    const visibleIntegrations = isExpanded ? integrations : integrations.slice(0, 3);
    const hasMore = integrations.length > 3;

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Third Party Integrations</h4>
            <div style={{
                backgroundColor: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '6px',
                padding: '20px'
            }}>
                <div style={{
                    fontSize: '12px',
                    color: '#a0a0a0',
                    textTransform: 'uppercase',
                    marginBottom: '12px',
                    fontWeight: '600',
                    letterSpacing: '0.5px'
                }}>
                    Integration Pages ({integrations.length} integrations)
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {visibleIntegrations.map(([integrationName, urls]) => {
                        if (!Array.isArray(urls) || urls.length === 0) {
                            return null;
                        }
                        return (
                            <div key={integrationName} style={{
                                backgroundColor: '#262626',
                                border: '1px solid #373737',
                                borderRadius: '4px',
                                padding: '12px'
                            }}>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#e0e0e0',
                                    marginBottom: '8px'
                                }}>
                                    {integrationName}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    {urls.map((url, index) => (
                                        <a
                                            key={index}
                                            href={url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: '#60a5fa',
                                                textDecoration: 'none',
                                                fontSize: '13px',
                                                padding: '6px 10px',
                                                backgroundColor: '#1f1f1f',
                                                borderRadius: '3px',
                                                border: '1px solid #2d2d2d',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = '#262626';
                                                e.target.style.textDecoration = 'underline';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = '#1f1f1f';
                                                e.target.style.textDecoration = 'none';
                                            }}
                                        >
                                            {url}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>
                {hasMore && (
                    <button
                        onClick={() => setIsExpanded(!isExpanded)}
                        style={{
                            marginTop: '16px',
                            padding: '8px 16px',
                            backgroundColor: '#3d3d3d',
                            border: '1px solid #505050',
                            borderRadius: '4px',
                            color: '#e0e0e0',
                            fontSize: '13px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            alignSelf: 'flex-start'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#4d4d4d';
                            e.target.style.borderColor = '#606060';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#3d3d3d';
                            e.target.style.borderColor = '#505050';
                        }}
                    >
                        {isExpanded ? `Show Less` : `Show More (${integrations.length - 3} more)`}
                    </button>
                )}
            </div>
        </div>
    );
};

export default ThirdPartyIntegrationsUrlsSection;

